export default __webpack_public_path__ + "static/media/banner2.ffc7af26.png";